import React, { useContext, useEffect, useLayoutEffect, useState } from 'react';
import Checkbox from '../Checkbox';
import { useGlobalState } from '../../stateProvider/StateProvider';
import { FormContext } from '../Form';
import Collapsible from '../../layout/Collapsable';

const LocationSelectors = ({ ...props }) => {
    const { state: { locations, }, } = useGlobalState();
    const formName = props.name || 'locations';
    const context = useContext(FormContext);
    const [state, setState] = useState(false);
    const [missing, setMissing] = useState(!context.values[formName]);

    useLayoutEffect(() => {
        if (context.values && missing) {
            context.setValues(v => ({ ...v, [formName]: [] }))
            setMissing(false)
        }
    }, [])

    useEffect(() => {
        if (context.values) {
            if (missing) { return };
            setState(context.values[formName].length === 0);
        }
    }, [context.values[formName]])

    const toggleState = () => {
        if (state) { return } else {
            setState(!state)
            context.setValues(v => ({ ...v, [formName]: [] }))
        };
    }

    return (
        <>
            <b>Allowed Locations</b>
            <Collapsible
                startState={context.values[formName]?.length > 0 ? false : true}
                label={context.values ?
                    <Checkbox
                        label='Works at all Locations'
                        value={state}
                        onClick={toggleState}
                        readOnly
                        standalone
                    /> : null}>
                {locations.map((e, i) => (
                    <Checkbox
                        key={'allowedLocations' + i}
                        name={formName}

                        label={e.label}
                        value={e.value}
                    />
                ))}
            </Collapsible>
        </>
    )
}

export default LocationSelectors;
